module.exports = __webpack_public_path__ + "static/en-303d971fe1d0b59cbc144c3f5c958f08.svg";